function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.9994 4.86719L19.9994 20.8672M16.4994 17.623C15.1468 18.3517 13.618 18.867 11.9994 18.867C8.46875 18.867 5.36575 16.415 3.58632 14.646C3.11661 14.179 2.8818 13.9456 2.73231 13.4873C2.6257 13.1605 2.62567 12.5738 2.73231 12.2469C2.88185 11.7887 3.11715 11.5546 3.58778 11.0869C4.48467 10.1954 5.71752 9.13078 7.17171 8.29395M19.4994 15.5006C19.8325 15.2077 20.1375 14.9195 20.4112 14.6475L20.4141 14.6444C20.8827 14.1786 21.1177 13.9451 21.2669 13.4878C21.3736 13.161 21.3733 12.574 21.2667 12.2472C21.1173 11.7891 20.8822 11.5549 20.4128 11.0883C18.6334 9.31927 15.5301 6.86719 11.9994 6.86719C11.6619 6.86719 11.3283 6.88959 10.9994 6.93167M13.3223 14.3672C12.9697 14.6784 12.5066 14.8672 11.9994 14.8672C10.8948 14.8672 9.9994 13.9718 9.9994 12.8672C9.9994 12.3277 10.213 11.8383 10.5603 11.4785",
  stroke: "#707274",
  strokeOpacity: 0.65,
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.5b36602f.svg";
export { ForwardRef as ReactComponent };